// extracted by mini-css-extract-plugin
module.exports = {"Message":"Message_Message__L9LXR","Self":"Message_Self__13TvW","Other":"Message_Other__oJUsj","List":"Message_List__2gCgE","Line":"Message_Line__2BXnb"};